import { Avatar, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next';
import Colors from '../../../themes/Colors';

const SyncCircuitAlert = () => {
    const { t } = useTranslation();

    return (
        <Tooltip
        title={t("The screens of this circuit are synchronized")}
        >
            <Avatar style={{ backgroundColor: Colors.green }} icon="sync" size="small"/>
        </Tooltip>
    )
}

export default SyncCircuitAlert